import React from 'react';
import { reportFrontendDiagnostic } from '@/lib/frontendDiagnostics';

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<
  React.PropsWithChildren,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    reportFrontendDiagnostic('react_render_error', error, {
      componentStack: info.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="flex min-h-screen items-center justify-center bg-background p-6">
          <section className="max-w-lg text-center">
            <h1 className="text-xl font-semibold">Não foi possível carregar esta tela</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              O erro foi registrado para análise. Recarregue a página para continuar.
            </p>
            <button
              className="mt-5 rounded-md bg-primary px-4 py-2 text-primary-foreground"
              onClick={() => window.location.reload()}
            >
              Recarregar página
            </button>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}
